import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { withSetPropAction } from '../extensions/withSetPropAction';

export const AlertStore = types
  .model('AlertStore', {
    open: types.optional(types.boolean, false),
    title: types.optional(types.string, ''),
    content: types.optional(types.string, ''),
  })
  .volatile(() => ({
    onClick: () => {
      // do nothing
    },
  }))
  .actions(withSetPropAction)
  .actions((self) => ({
    setOnClick(func: VoidFunction) {
      self.onClick = func;
    },
  }))
  .actions((self) => ({
    closeAlert() {
      self.setProps({
        open: false,
        title: '',
      });
    },
    invokeOnClick() {
      if (self.onClick) {
        self.onClick();
        // 초기화
        self.setOnClick(() => {
          // do nothing
        });
      }
    },
  }));

type TAlertStore = Instance<typeof AlertStore>;
type TAlertStoreSnapshot = SnapshotOut<typeof AlertStore>;
export interface IAlertStore extends TAlertStore {}
export type TAlertStoreKeys = keyof TAlertStoreSnapshot & string;
export interface IAlertStoreSnapshot extends TAlertStoreSnapshot {}
